export default __webpack_public_path__ + "static/media/KOD0155-min.a7e435bc.webp";